import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class FieldReviewDashboardService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getFieldReviewData(data): Observable<any> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.ALL_USERS_MAIL_ID.FIELD_REVIEW}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  updateFieldReview(data): Observable<any[]> {
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.ALL_USERS_MAIL_ID.FIELD_REVIEW}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

}
